import script from "./ExamSkillItemReport.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamSkillItemReport.vue?vue&type=script&setup=true&lang=ts"

import "./ExamSkillItemReport.vue?vue&type=style&index=0&id=77d94418&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77d94418"]])

export default __exports__